<template>
  <div class="text-left">
    <v-card class="exhibit-height">
      <v-card-title>
        List of Files:
      </v-card-title>
      <v-card-text v-if="filteredExhibits.length !== 0">
        <v-list
          two-line
          max-height="50vh"
          style="overflow-y:auto;"
        >
          <v-list-item
            v-for="(item, index) in filteredExhibits"
            :key="index"
          >
            <v-list-item-avatar>
              <v-icon
                v-if="files[item.file.split('.').pop().toLowerCase()]"
              >
                {{ files[item.file.split('.').pop().toLowerCase()] }}
              </v-icon>
              <v-icon
                v-else
              >
                {{ files["file"] }}
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content
              v-if="!filteredExhibits[index].edit"
              class="item-name"
            >
              {{ item.name }}
            </v-list-item-content>
            <v-list-item-content
              v-else
            >
              <v-text-field
                v-model.trim="fileName[index]"
                :placeholder="item.name"
                class="edit-text"
              />
              <v-btn
                class="name-edit"
                :disabled="!fileName[index]"
                outlined
                @click="edit(item, fileName[index], index)"
              >
                Submit
              </v-btn>
            </v-list-item-content>
            <v-list-item-action>
              <v-menu
                bottom
                right
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    class="download-option"
                    @click="forceFileDownload(item)"
                  >
                    <v-list-item-title>
                      Download
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :href="item.file"
                    target="_blank"
                  >
                    <v-list-item-title class="open-option">
                      Open In New Tab
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    class="edit-option"
                    @click="editMode(index)"
                  >
                    <v-list-item-title
                      v-if="filteredExhibits[index].edit"
                    >
                      Cancel Rename
                    </v-list-item-title>
                    <v-list-item-title
                      v-else
                    >
                      Rename File
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    class="delete-option"
                    @click="deleteExhibit(item)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-text v-else>
        This Survey Has No Files To Display.
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
export default {
  name: "StakeholderFiles",
  data() {
    return {
      fileName: [],
      editFlag: [],
      files: {
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-json",
        md: "mdi-markdown",
        pdf: "mdi-file-pdf",
        png: "mdi-file-image",
        jpg: "mdi-file-image",
        jpeg: "mdi-file-image",
        gif: "mdi-file-image",
        svg: "mdi-file-image",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
        csv: "mdi-file-excel",
        file: "mdi-file"
      },
    };
  },
  computed: {
    ...mapState({
      exhibits: state => state.exhibits.exhibits,
      selectedSurveyNumberForExhibits: state => state.survey.selectedSurveyNumberForExhibits
    }),
    filteredExhibits() {
      return this.exhibits.filter(exhibit => exhibit.survey === this.selectedSurveyNumberForExhibits.pk)
    }
  },
  mounted() {
    this.fetchExhibits();
  },
  methods: {
    ...mapActions("exhibits", ["fetchExhibits", "deleteExhibit", "editExhibitName"]),
    forceFileDownload(exhibit) {
      axios({method: 'get', url: exhibit.file, responseType: 'arraybuffer' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const type = exhibit.file.split('.').pop()
          let downloadName = exhibit.name.includes('.') ? exhibit.name : `${exhibit.name}.${type}`
          link.href = url
          link.setAttribute('download', downloadName)
          document.body.appendChild(link)
          link.click()
        })
    },
    editMode(index) {
      this.filteredExhibits[index].edit = !this.filteredExhibits[index].edit
    },
    edit(exhibit, name, index) {
      const payload = {exhibit: exhibit, name: name}
      this.editExhibitName(payload).then(() => {
        this.filteredExhibits[index].edit = !this.filteredExhibits[index].edit
        this.fileName[index] = null
      })
    }
  }
};
</script>

<style>
.match-height {
  height: 100% !important;
}
</style>

<style scoped>
.v-list-item__content {
  display: -webkit-box;
}
.name-edit {
  margin-left: -5%;
}
.edit-text >>> .v-input__slot {
  width: 95% !important;
}
.edit-text {
  flex: 1 1 auto !important;
}
</style>